import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { TabMenu } from "primereact/tabmenu";
import "./FailureAnalysis.css"; // estilo separado para customização verde

const FailureAnalysis: React.FC = () => {
  const [selectedCause, setSelectedCause] = useState<string | null>(null);
  const causeOptions = [
    { label: "Mão de Obra", value: "Mão de Obra" },
    { label: "Máquina", value: "Máquina" },
    { label: "Material", value: "Material" },
    { label: "Medição", value: "Medição" },
    { label: "Meio Ambiente", value: "Meio Ambiente" },
    { label: "Método", value: "Método" },
  ];

  const items = [
    { label: "Planejamento e Preparação" },
    { label: "Análise da Estrutura" },
    { label: "Análise de Função" },
    { label: "Análise de Falha" },
    { label: "Análise de Risco" },
    { label: "Otimização" },
    { label: "Documentação dos Resultados" },
  ];

  return (
    <div className="fmea-container">
      <TabMenu
        model={items}
        activeIndex={3}
        className="tab-green text-center"
      />

      <div className="info-section">
        <p>
          <strong>Tipo FMEA:</strong> AIAG/VDA
        </p>
        <p>
          <strong>Falha:</strong> Solda Incompleta
        </p>
        <p>
          <strong>Operação:</strong> OP20
        </p>
        <p>
          <strong>Passo atual:</strong> 4º Passo – Análise de Falha
        </p>
      </div>

      <div className="form-section">
        <label htmlFor="efeito">
          <strong>Efeito da Falha:</strong>
        </label>
        <InputTextarea id="efeito" rows={3} className="input-green" />

        <label htmlFor="modo">
          <strong>Modo de Falha:</strong>
        </label>
        <InputText id="modo" className="input-green" />

        <label htmlFor="causa">
          <strong>Causa da Falha:</strong>
        </label>
        <Dropdown
          id="causa"
          value={selectedCause}
          options={causeOptions}
          onChange={(e) => setSelectedCause(e.value)}
          placeholder="Selecione a causa"
          className="input-green dropdown-green"
        />
      </div>
    </div>
  );
};

export default FailureAnalysis;
